var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 119.06299212598425",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 119.062996l-100.0 0l0 -119.062996z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 119.062996l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d9d9d9",
    d: "m10.692913 14.980577l0 0c0 -7.23638 5.8662453 -13.102625 13.102625 -13.102625l52.40892 0l0 0c3.4750366 0 6.8077393 1.380451 9.264954 3.8376696c2.457222 2.4572186 3.8376694 5.789922 3.8376694 9.2649555l0 89.10184c0 7.2363815 -5.8662415 13.102623 -13.102623 13.102623l-52.40892 0c-7.2363796 0 -13.102625 -5.8662415 -13.102625 -13.102623z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m10.692913 14.980577l0 0c0 -7.23638 5.8662453 -13.102625 13.102625 -13.102625l52.40892 0l0 0c3.4750366 0 6.8077393 1.380451 9.264954 3.8376696c2.457222 2.4572186 3.8376694 5.789922 3.8376694 9.2649555l0 89.10184c0 7.2363815 -5.8662415 13.102623 -13.102623 13.102623l-52.40892 0c-7.2363796 0 -13.102625 -5.8662415 -13.102625 -13.102623z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m29.921259 22.485565l4.000002 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m29.921259 22.485565l4.000002 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m61.90026 22.485565l4.0 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.90026 22.485565l4.0 -7.1338587l4.0 7.1338587l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m29.921259 94.632545l4.000002 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m29.921259 94.632545l4.000002 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m61.90026 94.632545l4.0 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m61.90026 94.632545l4.0 -7.1338577l4.0 7.1338577l-4.0 7.1338577z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m78.29396 91.62467l1.5118103 -2.6929169l1.5118179 2.6929169l-1.5118179 2.6929169z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m78.29396 91.62467l1.5118103 -2.6929169l1.5118179 2.6929169l-1.5118179 2.6929169z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0000",
    d: "m18.0 25.847769l1.5118103 -2.692913l1.5118122 2.692913l-1.5118122 2.692913z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ff0000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m18.0 25.847769l1.5118103 -2.692913l1.5118122 2.692913l-1.5118122 2.692913z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m7.3708973 0.06824147l22.393702 0l0 32.31496l-22.393702 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m19.292772 19.30824l0 -1.9375l-2.65625 0l0 -1.3125l2.25 -5.375l2.0625 0l0 5.359375l0.796875 0l0 1.328125l-0.796875 0l0 1.9375l-1.65625 0zm-1.296875 -3.265625l1.296875 0l0 -3.59375l-1.296875 3.59375z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m92.57006 117.46372l-22.3937 0l0 -32.314964l22.3937 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m80.648186 98.22372l0 1.9375l2.65625 0l0 1.3125l-2.25 5.375l-2.0625 0l0 -5.359375l-0.796875 0l0 -1.328125l0.796875 0l0 -1.9375l1.65625 0zm1.296875 3.265625l-1.296875 0l0 3.59375l1.296875 -3.59375z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/Four.d6db04b090c64997de1c7457daa063f8.svg";
export { ForwardRef as ReactComponent };